export default __webpack_public_path__ + "static/media/CorpConsole.1500310fc61f7d0dc2bb78c64b30dcee.webp";